import React, { useEffect } from "react";
import { MdDoubleArrow } from "react-icons/md";
import { Link } from "react-router-dom";
import gameImage from "../../Img/game.jpg";
import { FaCar, FaCrosshairs, FaFemale, FaPuzzlePiece, FaBolt, FaShieldAlt } from "react-icons/fa";

const HeroSection = () => {

useEffect(() => {
  const loadAOS = async () => {
    const AOS = await import('aos');
    AOS.init({
      duration: 500,
      easing: "ease-out-cubic",
      once: true,
      offset: 100
    });
  };
  loadAOS();
}, []);

  return (
    <section className="relative lg:px-8 text-white sm:py-20 py-10 overflow-hidden bg-gradient-to-br from-[#0f172a] via-[#0a0f1f] to-[#020617]">
      <div className="container mx-auto px-4">
        <div className="flex md:flex-nowrap flex-wrap items-center">
          <div className="lg:w-3/5 md:w-1/2 w-full">
            <h2 data-aos="fade-up" data-aos-delay="200" className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-extrabold leading-tight">
              Your Daily Dose of{" "}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
                Free Online Games
              </span>{" "}
              <br /> Without the Wait 🎮
            </h2>

            {/* 🚀 NATURAL HUMAN WRITTEN TEXT FOR HIGH VALUE CONTENT */}
            <p data-aos="fade-up" data-aos-delay="400" className="sm:text-lg text-[16px] text-gray-300 mt-6 md:pe-10 lg:me-10 leading-relaxed font-light">
              We know that when you want to play a game, you want to play it right now. That is why <strong>Game Zone Hub</strong> is built differently. We host a massive collection of <strong>HTML5 games</strong> that load instantly in your browser. Whether you are taking a quick 5-minute break from studying or spending hours relaxing on the weekend, we have games that fit your mood.
            </p>
            <p data-aos="fade-up" data-aos-delay="500" className="sm:text-lg text-[16px] text-gray-300 mt-4 md:pe-10 lg:me-10 leading-relaxed font-light">
              There is no need to create an account, enter any credit card details, or wait for huge files to download. It is just pure, safe, and <strong>unblocked gaming fun</strong> that works perfectly whether you are using a laptop or swiping on your mobile phone.
              <br className="hidden md:block" />
              <span className="mt-4 flex flex-wrap gap-4 text-cyan-200 font-semibold text-sm">
                <span className="flex items-center gap-1"><FaBolt className="text-yellow-400"/> Zero Downloads</span>
                <span className="flex items-center gap-1"><FaShieldAlt className="text-green-400"/> 100% Safe to Play</span>
                <span className="flex items-center gap-1">📱 Works on All Devices</span>
              </span>
            </p>

            <div data-aos="zoom-in" data-aos-delay="600" className="flex mt-8 flex-row gap-4 md:justify-start">
              <Link
                to="/games"
                className="sm:px-8 sm:py-4 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-full font-bold flex items-center gap-3 hover:from-blue-500 hover:to-blue-400 transition-all duration-300 shadow-[0_0_20px_rgba(59,130,246,0.4)] hover:scale-105"
                aria-label="Play Free Online Games Now"
              >
                Browse All Games <MdDoubleArrow size={20} />
              </Link>
            </div>

           <div className="mt-8 text-sm text-gray-400 flex flex-wrap gap-3" data-aos="fade-up" data-aos-delay="700">
             
             <Link to="/games?category=car" aria-label="Browse Car Games" className="group cursor-pointer flex items-center gap-2 px-5 py-2 rounded-full 
               bg-white/5 border border-white/10 
               transition-all duration-300 ease-out 
               hover:bg-blue-500/10 hover:border-blue-400/40 
               hover:text-white hover:scale-105 hover:shadow-[0_0_15px_rgba(59,130,246,0.6)]">
               <FaCar className="text-blue-400 group-hover:rotate-6 transition-transform duration-300" />
               Car & Driving
             </Link>
           
             <Link to="/games?category=shooting" aria-label="Browse Shooting Games" className="group cursor-pointer flex items-center gap-2 px-5 py-2 rounded-full 
               bg-white/5 border border-white/10 
               transition-all duration-300 ease-out 
               hover:bg-red-500/10 hover:border-red-400/40 
               hover:text-white hover:scale-105 hover:shadow-[0_0_15px_rgba(239,68,68,0.6)]">
               <FaCrosshairs className="text-red-400 group-hover:scale-110 transition-transform duration-300" />
               Action & Shooter
             </Link>
           
             <Link to="/games?category=puzzle" aria-label="Browse Puzzle Games" className="group cursor-pointer flex items-center gap-2 px-5 py-2 rounded-full 
               bg-white/5 border border-white/10 
               transition-all duration-300 ease-out 
               hover:bg-green-500/10 hover:border-green-400/40 
               hover:text-white hover:scale-105 hover:shadow-[0_0_15px_rgba(34,197,94,0.6)]">
               <FaPuzzlePiece className="text-green-400 group-hover:-rotate-6 transition-transform duration-300" />
               Brain Puzzles
             </Link>
           
             <Link to="/games?category=girls" aria-label="Browse Girls Games" className="group cursor-pointer flex items-center gap-2 px-5 py-2 rounded-full 
               bg-white/5 border border-white/10 
               transition-all duration-300 ease-out 
               hover:bg-pink-500/10 hover:border-pink-400/40 
               hover:text-white hover:scale-105 hover:shadow-[0_0_15px_rgba(236,72,153,0.6)]">
               <FaFemale className="text-pink-400 group-hover:scale-110 transition-transform duration-300" />
               Casual & Fun
             </Link>
            </div>

          </div>

          <div data-aos="fade-left" data-aos-delay="300" className="relative lg:w-2/5 md:w-1/2 w-full md:mt-0 mt-12 pl-0 md:pl-6">
            <div
              className="relative group rounded-3xl overflow-hidden shadow-[0_10px_35px_rgba(0,150,255,0.25)] transition-all duration-500 hover:scale-[1.03] hover:rotate-1 hover:shadow-[0_20px_45px_rgba(0,150,255,0.45)] cursor-pointer border border-white/10"
            >
              <picture>
                <source srcSet={gameImage} type="image/webp" />
                 <img
                   src={gameImage}
                   alt="Play the best free HTML5 games instantly on your PC or mobile at Game Zone Hub"
                   className="object-cover w-full h-full transform transition-transform duration-700 group-hover:scale-110"
                   fetchpriority="high"
                   loading="eager"
                   decoding="async"
                 />
              </picture>

              <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-transparent to-white/10 opacity-60 group-hover:opacity-40 transition-opacity duration-500"></div>

              <div className="absolute inset-0 border-2 border-transparent group-hover:border-cyan-400/60 rounded-3xl transition-all duration-500"></div>
            </div>

            <div className="absolute -z-10 top-10 -left-10 w-80 h-80 bg-blue-600 rounded-full mix-blend-screen filter blur-[80px] opacity-40 animate-pulse"></div>
            <div className="absolute -z-10 bottom-10 -right-10 w-80 h-80 bg-purple-600 rounded-full mix-blend-screen filter blur-[80px] opacity-40 animate-pulse" style={{ animationDelay: '1s' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;